window.addEventListener('load', function () {
    var headerPartial = document.querySelector('.header__partial');

    if (headerPartial) {
        var width = headerPartial.getBoundingClientRect().width + 'px';

        var styleElement = document.createElement('style');

        styleElement.textContent = `
            @keyframes headerRibbon{0%{transform:translateX(0);}100%{transform:translateX(-${width});}}.header__ribbon{animation: headerRibbon 20s linear infinite;}
        `;

        document.head.appendChild(styleElement);
    } else {
        console.warn('Element with class "header__partial" not found.');
    }
});
